// // Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
// // Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
// define('membershipdirectory.Details.View', [
//     'SCView',
//     'Utils',
//     'membershipdirectory.Helper',
//     'membershipdirectory_details.tpl'
// ], function (
//     SCViewModule,
//     Utils,
//     membershipdirectoryHelper,
//     membershipdirectory_details_tpl
// ) {
//     'use strict';

//     var SCView = SCViewModule.SCView;

//     function MembershipDirectoryDetailsView (options) {
//         SCView.call(this, options);

//         this.model = options.model;

//         this.template = membershipdirectory_details_tpl;
//         //this.Environment = options.application.getComponent('Environment');
//         var self = this;
//         this.application = options.application;
//         this.collection = options.collection;
//     }

//     MembershipDirectoryDetailsView.prototype = Object.create(SCView.prototype);
//     MembershipDirectoryDetailsView.prototype.constructor = MembershipDirectoryDetailsView;

//     MembershipDirectoryDetailsView.prototype.getContext = function () {
//         return {
//             model: this.model
//             //typeOptions: membershipdirectoryHelper.getTypeOptions()
//         }
//     }

//     return MembershipDirectoryDetailsView
// })



define('membershipdirectory.Details.View',
  [
  'Backbone',
  'membershipdirectory_details.tpl'

  ],
  function 
  (
    Backbone, 
    membershipdirectory_details_tpl

  ) 
  {
    'use strict';

    return Backbone.View.extend({
      template: membershipdirectory_details_tpl

    , initialize: function (options) {     
        
        var self = this;
        this.application = options.application;
        this.collection = options.collection
    }
  
    ,  getContext: function () {
        return {
            model: this.model || []
        }
      }    

    });
  }
);
